/**
 * Storage key constants
 */

export const STORAGE_KEYS = {
  TOKEN: "token",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
